import { render } from "./SSN.vue?vue&type=template&id=dbd42ff0&scoped=true"
import script from "./SSN.vue?vue&type=script&lang=js"
export * from "./SSN.vue?vue&type=script&lang=js"

import "./SSN.vue?vue&type=style&index=0&id=dbd42ff0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd42ff0"]])

export default __exports__